"use strict";

exports.__esModule = true;
exports.sanitizeContent = sanitizeContent;
var _excluded = ["content"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _require = require('lodash'),
    map = _require.map,
    omit = _require.omit;

function sanitizeContent(_ref) {
  var content = _ref.content,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var blocks = map(content.blocks, removeRedundantTextAlignment);
  return _objectSpread(_objectSpread({}, rest), {}, {
    content: _objectSpread(_objectSpread({}, content), {}, {
      blocks: blocks
    })
  });
}
/*
 Removes text alignment from atomic blocks, because when atomic block is in selection range it's possible to set it's data.textAlignment prop.
 Removes left text alignment from text blocks, because it's a default value.
 */


function removeRedundantTextAlignment(block) {
  return block.type === 'atomic' ? omitTextAlignment(block) : omitLeftTextAlignment(block);
}

function omitLeftTextAlignment(block) {
  return block.data.textAlignment === 'left' ? omitTextAlignment(block) : block;
}

function omitTextAlignment(block) {
  return omit(block, 'data.textAlignment');
}